import { useState } from 'react';
import { toast } from 'react-toastify';
import { useAppDispatch } from '../../app/hooks';
import { ImagesTable } from '../images/images-table';
import {
  useDeleteImageMutation,
  useDeleteImagesMutation,
} from '../images/images.api';
import { open } from '../modal/modalSlice';
import { Pager } from '../pager/pager';
import { TableActionsBar } from 'shared-components';
import { useGetAlbumImagesQuery } from './albums.api';
import { IAlbum, IImage } from '@topshots/core-models';

export const AlbumImages = ({ album }: { album: IAlbum }) => {
  const [page, setPage] = useState<number>(1);
  const dispatch = useAppDispatch();
  const [perPage, setPerPage] = useState<number>(10);
  const [deleteImage] = useDeleteImageMutation();
  const [deleteMultipleImages] = useDeleteImagesMutation();
  const { data, isLoading, isFetching } = useGetAlbumImagesQuery({
    id: album._id.toString(),
    page,
    perPage,
  });
  const [selected, setSelected] = useState<IImage[]>([]);
  if (isLoading || isFetching) return <span>loading...</span>;
  return (
    <>
      <TableActionsBar
        showBulkActions={selected.length > 0}
        bulkActions={[
          {
            action: async () => {
              if (
                // eslint-disable-next-line no-restricted-globals
                confirm(
                  `Are you sure you want to delete ${selected.length} images?`
                )
              ) {
                await deleteMultipleImages(
                  selected.map((image) => image._id.toString())
                );
                toast.success('Images deleted');
              }
            },
            display: 'Delete',
            value: 'delete',
          },
        ]}
        singularActions={[
          {
            action: () => {
              dispatch(
                open({
                  title: 'Upload Images',
                  contentKey: 'album-image-upload',
                  contentPayload: {
                    albumId: album._id,
                  },
                })
              );
            },
            display: 'Upload Images',
            value: 'upload-images',
          },
        ]}
      />
      <ImagesTable
        onSelectedChanged={(selected) => {
          setSelected(selected);
        }}
        images={data?.data ?? []}
        onDelete={async (image) => {
          // eslint-disable-next-line no-restricted-globals
          if (confirm(`Are you sure you want to delete ${image.name}?`)) {
            await deleteImage(image._id.toString());
            toast.success('Image deleted');
          }
        }}
      />
      <Pager
        onNext={() => {
          setPage(page + 1);
        }}
        onPrevious={() => {
          setPage(page - 1);
        }}
        onPageSelected={(selected) => {
          setPage(selected);
        }}
        onPerPageChange={(selected) => {
          setPerPage(selected);
          setPage(1);
        }}
        page={page}
        perPage={perPage}
        totalPages={data?.totalPages ?? 1}
      />
    </>
  );
};
